export function normalizeRotationAngle(angle) {
  return (((Number(angle) || 0) % 360) + 360) % 360;
}

export function getCycleImagePrefix(cycleName) {
  const name = String(cycleName || "").trim();
  if (!name) {
    return "";
  }
  const cameraMarkerIndex = name.indexOf("-camera-");
  if (cameraMarkerIndex >= 0) {
    return name.slice(0, cameraMarkerIndex);
  }
  return name;
}

function getSideImageMarker(side) {
  return side === "right" ? "-R" : "-L";
}

export function getAppliedRotationForCycle(monitoringEntries, cycleName, side) {
  if (!Array.isArray(monitoringEntries) || !cycleName) {
    return { angle: 0, matched: false };
  }

  const prefix = getCycleImagePrefix(cycleName);
  const sideMarker = getSideImageMarker(side);

  const match = monitoringEntries.find((entry) => {
    const imageName = String(entry?.image_name || "");
    return imageName.includes(sideMarker) && imageName.startsWith(prefix);
  });

  if (match?.rotation_angle === undefined || match?.rotation_angle === null) {
    return { angle: 0, matched: false };
  }

  const angle = Number(match.rotation_angle);
  if (!Number.isFinite(angle)) {
    return { angle: 0, matched: false };
  }

  return { angle: normalizeRotationAngle(angle), matched: true };
}

export function resolveAppliedRotation(appliedResult, targetAngle) {
  const target = normalizeRotationAngle(targetAngle);
  if (appliedResult.matched) {
    return {
      appliedAngle: normalizeRotationAngle(appliedResult.angle),
      appliedMatched: true,
    };
  }
  return { appliedAngle: target, appliedMatched: false };
}

export function computeRotationPreviewDelta(appliedAngle, targetAngle) {
  const applied = normalizeRotationAngle(appliedAngle);
  const target = normalizeRotationAngle(targetAngle);
  const rawDiff = (applied - target) % 360;
  return (rawDiff + 360) % 360;
}

export function areRotationAnglesInSync(appliedAngle, targetAngle) {
  return (
    normalizeRotationAngle(appliedAngle) === normalizeRotationAngle(targetAngle)
  );
}

export function getMaskImagePreviewGroupProps(
  previewDelta,
  imageWidth,
  imageHeight,
) {
  const delta = normalizeRotationAngle(previewDelta);
  return {
    rotation: delta,
    x: delta === 90 ? imageHeight : delta === 180 ? imageWidth : 0,
    y: delta === 180 ? imageHeight : delta === 270 ? imageWidth : 0,
    width: delta === 0 || delta === 180 ? imageWidth : imageHeight,
    height: delta === 90 || delta === 270 ? imageWidth : imageHeight,
  };
}

export function getMaskPreviewStageDimensions(
  imageWidth,
  imageHeight,
  previewDelta,
) {
  const delta = normalizeRotationAngle(previewDelta);
  if (delta === 90 || delta === 270) {
    return { width: imageHeight, height: imageWidth };
  }
  return { width: imageWidth, height: imageHeight };
}

export function formatRotationHubSubtitle(
  t,
  appliedAngle,
  targetAngle,
  appliedMatched,
) {
  const targetLabel = `${normalizeRotationAngle(targetAngle)}°`;
  if (!appliedMatched) {
    return t("installation_rotation_hub_unverified", { angle: targetLabel });
  }
  if (areRotationAnglesInSync(appliedAngle, targetAngle)) {
    return t("installation_rotation_hub_in_sync", { angle: targetLabel });
  }
  const appliedLabel = `${normalizeRotationAngle(appliedAngle)}°`;
  return t("installation_rotation_hub_pending", {
    applied: appliedLabel,
    target: targetLabel,
  });
}
